import { useContext } from 'react';
import SentryContext from './SentryContext';

export default function useSentry() {
  const sentry = useContext(SentryContext);
  return sentry;
}
